import styled from 'styled-components'

export const StyledStatusDiv = styled.div`
  min-width: 148px;
`
